import { combineReducers } from "redux";
import getFileReducer from "./getFileReducer";
import deleteFileReducer from "./deleteFileReducer";

const fileReducer = combineReducers({
    getFile: getFileReducer,
    deleteFile: deleteFileReducer
});

export default fileReducer;